import { createContext } from 'react'

export interface UnsavedChangesContextValue {
  isDirty: boolean
  setDirty: (next: boolean) => void
  confirmDiscard: () => Promise<boolean>
}

export const DEFAULT_UNSAVED_CHANGES_MESSAGE =
  'Você tem alterações não salvas. Deseja sair mesmo assim?'

export const UnsavedChangesContext = createContext<UnsavedChangesContextValue | null>(null)

export const locationToUrl = (location: {
  pathname: string
  search: string
  hash: string
}): string => `${location.pathname}${location.search}${location.hash}`

